import React from 'react';

const withCopyright = (WrappedComponent: any) => {
  return class WithCopyright extends React.Component {
    copyrightText = `Hayk Simonyan | Copyright © ${new Date().getFullYear()} all rights reserved | version - 2.0 | `;

    render() {
      return (
        <div>
          <WrappedComponent
            copyrightText={this.copyrightText}
            {...this.props}
          />
        </div>
      );
    }
  };
};

export default withCopyright;
